import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';
import EditButton from '../../../Assets/edit-button.svg';

// Custom css
import classes from './editButton.module.css';

interface Props {
  className?: string;
  id?: string;
  onClick?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}
const EditButtonSvg = ({ className = '', id, onClick, onKeyUp }: Props) => (
  <EditButton id={id} className={`${classes.editButtonBase} ${className || ''}`} onClick={onClick} onKeyUp={onKeyUp} />
);

EditButtonSvg.defaultProps = {
  className: undefined,
  id: undefined,
  onClick: undefined,
  onKeyUp: undefined,
};

const EditButtonSvgMemo = memo(EditButtonSvg, areEqualShallow);
export { EditButtonSvgMemo as EditButtonSvg };
